<div class="container-custom">
  <div class="table-header">
    <h2 class="title">
      Regla 2.3.8
    </h2>
  </div>

  <!-- Form -->
  <app-rule238-form
    #rule238Form
    (save)="saveRule238($event, Actions.Create)"
    (update)="saveRule238($event, Actions.Update)"
    (delete)="deleteRule238()"
    (goback)="navigateToShipDetails()"
    [canDelete]="canDelete"
    [rule238Update]="rule238"
    [wasCreatedUpdated]="wasCreatedUpdated"
  ></app-rule238-form>

</div>
<app-overlay
  *ngIf="loading"
></app-overlay>
<app-overlay
*ngIf="overlayError"
[reload]="true"
></app-overlay>
<!-- Overlay message -->
<app-overlay
  *ngIf="overlayMessage"
  [mensaje]="message"
  [icono]="icon"
></app-overlay>
